import React, { useContext, useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { ThemeContext } from '../contexts/ThemeContext';
import uzenetekImg from '../assets/images/uzenetek.jpg';
import { Typography, Box } from '@mui/material'; // Import Typography and Box from MUI
import './Animations.css'; // Import the CSS file
import { brandPalette } from '../theme/brand';

const CsillagPage = () => {
  const { darkMode } = useContext(ThemeContext)!;
  const pal = brandPalette(darkMode);
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    // You can adjust the delay before the text animation starts
    const delayBeforeTextAnimation = 1000; // 1 second delay after component mounts

    const timer = setTimeout(() => {
      setShowComingSoon(true);
    }, delayBeforeTextAnimation);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <Box
        sx={{
          height: '100vh',
          width: '100%',
          backgroundColor: 'transparent',
          display: 'flex',
          flexDirection: 'column', // Changed to column to stack image and text
          justifyContent: 'flex-end', // Aligns content to the bottom
          alignItems: 'center', // Centers horizontally
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Typography
          variant="h3" // Choose an appropriate heading size
          component="h1"
          sx={{
            color: pal.heading,
            fontWeight: 800,
            fontSize: { xs: '1.9rem', sm: '2.4rem', md: '3rem' },
            textShadow: darkMode ? '0 2px 10px rgba(0,0,0,0.45)' : 'none',
            position: 'absolute',
            top: '25%', // Start roughly in the middle, will animate up
            left: '50%',
            transform: 'translate(-50%, -50%)', // Center the text
            zIndex: 2, // Ensure text is above the image
            whiteSpace: 'nowrap', // Prevent text from wrapping
            opacity: 0, // Initially hidden
            transition: 'all 1s ease-out', // Smooth transition for animation
            ...(showComingSoon && {
              opacity: 1,
              transform: 'translate(-50%, -150%)', // Animate up above the image
            }),
          }}
        >
          Hamarosan . . . .
        </Typography>

        <img
          src={uzenetekImg}
          alt="Üzenetek telefon"
          className="slide-in-image" // Keep your existing image animation if desired
          style={{
            width: '90%',
            maxWidth: '600px',
            height: 'auto',
            zIndex: 1, // Ensure image is below the text
            marginBottom: '0px', // Add some space below the image if needed
          }}
        />
      </Box>
    </>
  );
};

export default CsillagPage;